<template>
    <div>
        <DTabs
            :items='[
                {"title":"Новости","const":"news"},
                {"title":"СМИ о нас","const":"smi"}
            ]'
            v-model="newsSwitcher"
            :modelValue="newsSwitcher"
            :stretch='true'
            color="black"
        />
    </div>
</template>

<script>
    import { ref, watch } from 'vue';
    import { getNews } from './services/getNews';
    import { useStore } from '../../store';
    import { DTabs } from '@ahml/domrfbank-ui/elements/DTabs';

    export default {
        name: "pressSwitcher",
        components: {
            DTabs
        },
        setup() {
            let newsSwitcher = ref('news');
            const store = useStore();

            watch(newsSwitcher , (val) => {
                store.commit('press/SET_SWITCHER_VAL', val);
                store.commit('press/SET_SEARCH_ERROR', false);
                store.commit('press/SET_PAGE_NUMBER', 1);
                store.commit('press/SET_CALENDAR_VAL', ['']);
                store.commit('press/SET_SEARCH_VAL', '');
                store.commit('press/CHANGE_FILTER', '');
                getNews();
            });

            return {
                newsSwitcher
            };

        },
    }
</script>
